import { useEffect, useMemo, useRef, useState } from "react";
import { Box, Grid, LinearProgress, Typography } from "@mui/material";
import Lottie from "lottie-react";
import astra from "assets/animations/bot/astra.json";
import solara from "assets/animations/bot/solaraagent 2.json";
import arrow from "assets/animations/bot/nextArrow.json";
import BotVcc from "assets/Icons/vccAgentBg.svg";
import { useNavigate, useLocation } from "react-router-dom";
import {
  ErrorToaster,
  // SuccessToaster
} from "components/Toaster";
import { startTTAgent } from "utils/lambda";
import { FontFamily } from "assets";
import success from "assets/animations/bot/Success.json";
import CenterDataJson from "assets/animations/bot/AI data progress.json";

const TTInvoiceAgent = () => {
  const [started, setStarted] = useState("idle");
  const navigate = useNavigate();
  const location = useLocation();

  const runProcessing = async () => {
    setStarted("running");
    try {
      const result = await startTTAgent();
      console.log(result, "result");
      setStarted("success");
      // navigate("/agents-progress");
    } catch (e) {
      setStarted("failed");
      console.error(e);
      ErrorToaster(e);
    } finally {
      setStarted("failed");
    }
  };

  // const getStatus = async () => {
  //   try {
  //     const response = await AgentBotServices.getAgentStatus();

  //     if (response?.data?.result?.success) {
  //       const result = response.data.result;
  //       const latestRecord = result.latestRecord || {};
  //       const uniqueRecord = result.uniqueCounts || {};
  //     }
  //   } catch (err) {
  //     console.error("❌ Polling failed:", err);
  //   }
  // };

  // useEffect(() => {
  //   let interval;
  //   if (started === "running") {
  //     interval = setInterval(() => {
  //       getStatus();
  //     }, 10000); // poll every 10s
  //   }
  //   return () => clearInterval(interval);
  // }, [started]);

  const handleClick = () => {
    navigate("/tt-attachments");
  };

  const STEPS = useMemo(
    () => [
      { name: "Agent Astra", duration: 10000 },
      { name: "Agent Solara", duration: 20000 },
    ],
    []
  );

  const [stepIndex, setStepIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const [finished, setFinished] = useState(false);
  const rafRef = useRef(null);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (finished) return;
    const duration = STEPS[stepIndex].duration;
    setProgress(0);
    startTimeRef.current = null;

    const tick = (t) => {
      if (startTimeRef.current == null) startTimeRef.current = t;
      const elapsed = t - startTimeRef.current;
      const pct = Math.min(100, (elapsed / duration) * 100);
      setProgress(pct);

      if (pct < 100) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        if (stepIndex < STEPS.length - 1) setStepIndex((i) => i + 1);
        else setFinished(true);
      }
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    };
  }, [STEPS, stepIndex, finished]);

  const currentAgent = STEPS[stepIndex].name;

  return (
    <>
      {started === "idle" ? (
        <Box
          sx={{
            width: "100%",
            overflowX: "hidden",
            overflowY: "auto",
            minHeight: "100vh",
            backgroundImage: `url(${BotVcc})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: "white",
            display: "flex",
            flexDirection: "column",
            py: 4,
          }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="flex-start"
            columnSpacing={4}
            rowSpacing={0}
            sx={{ maxWidth: "1400px", mx: "auto" }}
          >
            <Grid
              item
              md={5}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "left",
              }}
            >
              <Lottie
                animationData={astra}
                loop
                style={{
                  width: "271px",
                  height: "373px",
                }}
              />

              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "26px",
                  textAlign: "center",
                  color: "white",
                  border: "2px solid white",
                  borderRadius: "100px",
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  paddingRight: "50px",
                  paddingLeft: "50px",
                  marginBottom: "20px",
                  fontFamily: FontFamily.openSans,
                  fontWeight: 400,
                  fontStyle: "Regular",
                }}
              >
                Agent Astra
              </Typography>

              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#fff",
                  textAlign: "center",
                  mb: 2,
                  fontFamily: FontFamily.openSans,
                  fontWeight: 400,
                  fontStyle: "Regular",
                }}
              >
                Invoice Manager
              </Typography>

              <Box
                component="ul"
                sx={{
                  m: 0,
                  p: 0,
                  maxWidth: "320px",
                  color: "#fff",
                  fontSize: "20px",
                  lineHeight: 1.5,
                  fontFamily: FontFamily.openSans,
                  fontWeight: 400,
                  fontStyle: "Regular",
                  "& li": {
                    position: "relative",
                    paddingLeft: "20px",
                    marginBottom: "16px",
                    listStyle: "none",
                    fontFamily: FontFamily.openSans,
                    fontWeight: 400,
                    fontStyle: "Regular",
                  },
                  "& li::before": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    top: "8px",
                    width: "6px",
                    height: "6px",
                    backgroundColor: "#fff",
                    fontFamily: FontFamily.openSans,
                    fontWeight: 400,
                    fontStyle: "Regular",
                  },
                }}
              >
                <li>Agent uploads invoice and stores the invoice URL.</li>
                <li>
                  After uploading, Organizes data in the format required by
                  Galaxy ERP.
                </li>
                <li>
                  The data is handed over to the agent Solara in the workflow.
                </li>
              </Box>
            </Grid>

            <Grid
              item
              md={1}
              xs={12}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                pt: { md: "120px", xs: 2 },
              }}
              mt={7}
            >
              <Lottie
                animationData={arrow}
                loop
                style={{
                  width: "77px",
                  height: "93px",
                }}
              />
            </Grid>

            <Grid
              item
              md={5}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "left",
              }}
            >
              <Lottie
                animationData={solara}
                loop
                style={{
                  width: "271px",
                  height: "373px",
                }}
              />

              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "26px",
                  fontWeight: 600,
                  textAlign: "center",
                  color: "white",
                  border: "2px solid white",
                  borderRadius: "100px",
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  paddingRight: "50px",
                  paddingLeft: "50px",
                  marginBottom: "20px",
                  fontFamily: FontFamily.openSans,
                  fontWeight: 400,
                  fontStyle: "Regular",
                }}
              >
                Agent Solara
              </Typography>

              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#fff",
                  textAlign: "center",
                  mb: 2,
                  fontFamily: FontFamily.openSans,
                  fontWeight: 400,
                  fontStyle: "Regular",
                }}
              >
                TT Creator
              </Typography>

              <Box
                component="ul"
                sx={{
                  m: 0,
                  p: 0,
                  maxWidth: "320px",
                  color: "#fff",
                  fontSize: "20px",
                  lineHeight: 1.5,
                  fontWeight: 400,
                  fontFamily: FontFamily.openSans,
                  fontWeight: 400,
                  fontStyle: "Regular",
                  "& li": {
                    position: "relative",
                    paddingLeft: "20px",
                    marginBottom: "16px",
                    listStyle: "none",
                  },
                  "& li::before": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    top: "8px",
                    width: "6px",
                    height: "6px",
                    backgroundColor: "#fff",
                    fontFamily: FontFamily.openSans,
                    fontWeight: 400,
                    fontStyle: "Regular",
                  },
                }}
              >
                <li>
                  Checks existing records in the system based on Lot Number to
                  avoid duplication.
                </li>
                <li>
                  Processes and allocates the payable amount according to the
                  Buyer ID.
                </li>
                <li>
                  Handles different payment flows, including Partial, Complete,
                  and Extra amount scenarios.
                </li>
                <li>Finally, generates and creates the TT transaction.</li>
              </Box>
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#5BBC0F",
                border: "1px solid #5BBC0F",
                borderRadius: "100px",
                px: "24px",
                py: "12px",
                fontSize: "22px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                color: "#fff",
                fontFamily: FontFamily.openSans,
                fontStyle: "Regular",
              }}
              component="button"
              type="button"
              onClick={runProcessing}
              disabled={started !== "idle"}
            >
              <span>
                {started === "running" ? "Starting..." : "Start Processing Now"}
              </span>
              <span style={{ fontWeight: 700, fontSize: "18px" }}>➜</span>
            </Box>
          </Box>
        </Box>
      ) : started === "running" ? (
        <>
          <Box
            sx={{
              width: "100%",
              minHeight: "100vh",
              backgroundImage: `url(${BotVcc})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              py: { xs: 4, md: 6 },

              gap: "40px",
              pb: 3,
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: { xs: 16, md: 24 },
                width: "323px",
                height: "69px",
                right: { xs: 16, md: 32 },
                border: "2px solid #fff",
                borderRadius: "100px",
                px: "50px",
                py: "12px",
                textAlign: "center",
                fontSize: "36px",
                bgcolor: "rgba(0,0,0,0.15)",
                backdropFilter: "blur(2px)",
                fontFamily: FontFamily.openSans,
                fontWeight: 400,
                fontStyle: "Regular",
              }}
            >
              {currentAgent}
            </Box>
            {/* Stage area – stack children with a fixed 100px gap */}
            <Box
              sx={{
                width: "min(1200px, 92vw)",
                height: { xs: 460, md: 560 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "100px", // ⟵ exact space between the two Boxes
              }}
            >
              {/* Lottie – remove absolute positioning */}
              <Box sx={{ width: 749, height: 562, maxWidth: "100%" }}>
                <Lottie
                  animationData={CenterDataJson}
                  loop
                  style={{ width: "100%", height: "100%" }}
                />
              </Box>

              {/* Progress – remove absolute positioning */}
              <Box sx={{ width: { xs: "88vw", sm: 420, md: 590 } }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1.25,
                    px: 0.5,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "24px",
                      fontFamily: FontFamily.openSans,
                      fontWeight: 400,
                      fontStyle: "Regular",
                      opacity: 0.9,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {stepIndex === 0 && "Lot Number detected.."}
                    {stepIndex === 1 && "Invoice processed.."}
                    {stepIndex === 2 && "AI-Based analysis and TT creation.."}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "24px",
                      opacity: 0.9,
                      fontVariantNumeric: "tabular-nums",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {Math.round(progress)}%
                  </Typography>
                </Box>

                <LinearProgress
                  variant="determinate"
                  value={progress}
                  sx={{
                    height: "16px",
                    borderRadius: 999,
                    backgroundColor: "rgba(255,255,255,0.25)",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#22C55E",
                      borderRadius: 999,
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            backgroundImage: `url(${BotVcc})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: { xs: 4, md: 6 },

            gap: "40px",
            pb: 3,
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              // top: { xs: 16, md: 24 },
              // width: "323px",
              // height: "69px",
              // right: { xs: 16, md: 32 },
              // border: "2px solid #fff",
              // borderRadius: "100px",
              // px: "50px",
              // py: "12px",
              fontWeight: 600,
              textAlign: "center",
              alignItems: "center",
              // fontSize: "30px",
              bgcolor: "rgba(0,0,0,0.15)",
              backdropFilter: "blur(2px)",
            }}
          />
          <Box
            sx={{
              position: "relative",
              textAlign: "center",
              alignItems: "center",
              zIndex: 1,
            }}
          >
            <Box sx={{ width: 600, height: 400, mx: "auto" }}>
              <Lottie
                animationData={success}
                loop={false}
                style={{ width: "100%", height: "100%" }}
              />
            </Box>

            <Typography
              sx={{
                fontFamily: FontFamily.openSans,
                fontWeight: 400,
                fontStyle: "Regular",
                fontSize: "36px",
                mb: 1,
                textShadow: "0 1px 8px rgba(0,0,0,0.6)",
              }}
            >
              Job Completed Successfully!
            </Typography>
            <Typography
              sx={{
                fontSize: "30px",
                fontFamily: FontFamily.openSans,
                fontWeight: 400,
                fontStyle: "Regular",
                opacity: 0.95,
                maxWidth: 900,
                mx: "auto",
                lineHeight: 1.6,
              }}
              onClick={handleClick}
              style={{ cursor: "pointer" }}
            >
              You can now review detailed insights in the{" "}
              <span style={{ textDecoration: "underline" }}>
                Analytics section
              </span>
              .
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TTInvoiceAgent;
